import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiInterceptor } from './api.interceptor';
import { loadingInterceptor } from './loader.interceptor';
import { errorInterceptor } from './error.interceptor';

export const interceptorProviders = [
  provideHttpClient(
    withInterceptors([apiInterceptor, loadingInterceptor, errorInterceptor]),
  ),
];
